import firebase from "firebase";
import firestore from "../firebase/firestore";
import { getConsumerUnits } from "./consumer_units";
import { getBillingsByUserOpened } from "./billing";

export const uploadData = async ({ id, data, agent_email }) => {
  const storageRef = firebase.storage().ref();
  if (data) {
    for (let i = 0; i < data.length; i++) {
      const file = data[i];
      const fileName = file.data.name;
      let filePath = `users/${id}/document_photo/${fileName}`;
      let uploadFile = storageRef.child(filePath).put(file.data);

      await new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (s) => {
            console.log((s.bytesTransferred / s.totalBytes) * 100 + "%");
          },
          (error) => {
            console.error(error);
            reject(error);
          },
          async () => {
            try {
              const downloadURL =
                await uploadFile.snapshot.ref.getDownloadURL();
              await firestore
                .collection("users")
                .doc(id)
                .collection("document_photo")
                .doc(fileName)
                .set({
                  name: fileName,
                  url: downloadURL,
                  upload_at: new Date(),
                  type: file?.category?.type,
                  agent_email,
                });
              resolve();
            } catch (error) {
              console.error(error);
              reject(error);
            }
          },
        );
      });
    }
  }
};

export const uploadEnergyBillData = async ({ id, data, agent_email }) => {
  const storageRef = firebase.storage().ref();

  if (data && id) {
    for (const file of data) {
      if (!file) {
        console.error("Falha ao realizar upload de documentos.");
        throw new Error("Falha ao realizar upload de documentos.");
      }

      let filePath = `users/${id}/document_photo/${file.name}`;
      let uploadFile = storageRef.child(filePath).put(file);

      await new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (s) => {
            console.log((s.bytesTransferred / s.totalBytes) * 100 + "%");
          },
          (error) => {
            console.error(error);
            reject(error);
          },
          async () => {
            try {
              const downloadURL =
                await uploadFile.snapshot.ref.getDownloadURL();
              await firestore
                .collection("users")
                .doc(id)
                .collection("document_photo")
                .doc(file.name)
                .set({
                  name: file.name,
                  url: downloadURL,
                  upload_at: new Date(),
                  type: "energy_bill",
                  agent_email,
                });
              resolve();
            } catch (error) {
              console.error(error);
              reject(error);
            }
          },
        );
      });
    }
  } else {
    console.error("Falha ao realizar upload de documentos.");
    throw new Error("Falha ao realizar upload de documentos.");
  }
};

export const uploadEnergyBill = (email, file) => {
  try {
    const storageRef = firebase.storage().ref();
    if (email && file) {
      const filePath = `users/${email}/document_photo/${file.name}`;
      return storageRef.child(filePath).put(file);
    } else {
      console.error("Falha ao realizar upload de documentos.");
      throw new Error("Falha ao realizar upload de documentos.");
    }
  } catch (error) {
    console.error("Falha ao realizar upload de documentos: ", error);
    throw error;
  }
};

export const removeEnergyBill = (email, fileName) => {
  const storageRef = firebase.storage().ref();

  if (email && fileName) {
    let filePath = `users/${email}/document_photo/${fileName}`;
    storageRef
      .child(filePath)
      .delete()
      .catch((error) => {
        console.error("Falha ao remover arquivo de conta: ", error);
        throw error;
      });
  } else {
    console.error("Falha ao remover arquivo de conta.");
    throw new Error("Falha ao remover arquivo de conta.");
  }
};

export const saveEnergyBill = async (user_id, agent_email, files) => {
  const user = await firestore.collection("users").doc(user_id).get();
  console.log("user: ", user_id);
  if (!user.exists) {
    console.error("Membro não encontrado.");
    throw new Error("Membro não encontrado.");
  }

  for (const file of files) {
    await user.ref.collection("document_photo").doc(file.name).set({
      name: file.name,
      url: file.downloadURL,
      upload_at: new Date(),
      type: "energy_bill",
      agent_email,
    });
  }
};

export const uploadUcBilling = async ({ id, data }) => {
  const storageRef = firebase.storage().ref();

  if (data) {
    for (const file of data) {
      let filePath = `qualifications/${id}/${file.name}`;
      let metadata = { contentType: file.type };
      let uploadFile = storageRef.child(filePath).put(file, metadata);

      uploadFile.on(
        "state_changed",
        () => {},
        (error) => {
          console.error(error);
        },
        () => {
          firestore.collection("qualifications").doc(id).update({
            bill_uploaded_path: filePath,
            upload_at: new Date(),
          });
        },
      );
    }
  }
};

export const canSubscription = async (user) => {
  if (!user.customer_id) return true;

  if (
    user.signedcontract_by === "onboarding" &&
    user.signedcontract_source === "online" &&
    user.signedcontract_partner === "enercred" &&
    user.status === "ATIVO"
  )
    return false;

  const args = {
    searchBy: {
      field: "user_id",
      operator: "==",
      value: user.customer_id,
    },
  };
  const ucs = await getConsumerUnits(args).get();

  let contract_id = 0;
  contract_id = await ucs.docs.reduce(async (sum, cur) => {
    if (cur.data().status === "canceled") {
      // Verifica se há pendencias financeiras // Se não houver deve permitir a revenda com consentimento
      // Busca pendencias financeiras
      let billings = await getBillingsByUserOpened(user.id);
      if (billings.size > 0) return ++sum;
    }

    if (
      (cur.data().contract_id &&
        cur.data().contract_id !== "" &&
        cur.data().status !== "contract_not_signed" &&
        cur.data().status !== "canceled") ||
      cur.data().billing_competence_start
    ) {
      return ++sum;
    } else return sum;
  }, 0);

  if (
    user.signedcontract_by === "mobile_app" &&
    contract_id > 0 &&
    user.status === "ATIVO"
  ) {
    console.error(
      "Clientes que fizeram assinatura por app não podem ser revendidos",
    );
    return false;
  }

  return contract_id <= 0;
};
